/**
 * Content-minimization helpers for push notification text (pre-external-testing
 * security audit). Push notification TITLES/BODIES transit FCM/APNs and sit on
 * lock screens, so they must never carry PHI beyond a person's first name and
 * the session stage: no street addresses, no message content, no care details.
 * Full context stays in the push DATA payload and in-app surfaces, which are
 * delivered over the authenticated AppSync/REST channels instead.
 */

/**
 * First name only, for push bodies. Falls back to the provided label (e.g.
 * "Your provider") when no name is available.
 */
export function pushSafeFirstName(
  fullName: string | null | undefined,
  fallback = '',
): string {
  const first = (fullName ?? '').trim().split(/\s+/)[0] ?? ''
  return first || fallback
}
